<template>
  <!-- 导航开始 -->
  <div class='commonRecruiment' :class="{appBool:appBool}">
    <div class="topBox">
      <div class="infoBox">
        <div class="aa">
          <h3>{{info.name}} · {{info.experience}}</h3>
        </div>
        <div class="cc">
          <span>品级：<i>{{info.lavel_title}}</i></span>
          <span>来源：<i>{{info.source_title}}</i></span>
          <span>标签：<i>{{info.tage_title}}</i></span>
        </div>
        <div class="cc">
          <span>经验：<i>{{info.experience}}</i></span>
          <span>学历：<i>{{info.educational}}</i></span>
          <span>职位：<i>{{info.position}}</i></span>
        </div>
      </div>
      <div class="menuBox">
        <span @click="qiehuanFun('ui-recruiment-trace')" :class="{active:isCompnentElement==='ui-recruiment-trace'}">维护</span>
        <span @click="qiehuanFun('ui-recruiment-info')" :class="{active:isCompnentElement==='ui-recruiment-info'}">简历详情</span>
        <span @click="qiehuanFun('ui-recruiment-interview')" :class="{active:isCompnentElement==='ui-recruiment-interview'}">面试安排</span>
      </div>
    </div>
    <div class="mainBox">
      <component :parentInitResumeFun="initResumeFun" :token="token" :is="isCompnentElement"></component>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import uiRecruimentTrace from '@/components/common/recruiment/trace';
import uiRecruimentInfo from '@/components/common/recruiment/info';
import uiRecruimentInterview from '@/components/common/recruiment/interview';
import resultCommons from '@/util/resultcommons';

export default {
  name: 'commonRecruiment',
  props: {
    token: {
      type: String,
      default: '',
    },
    appBool: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCompnentElement: 'ui-recruiment-trace',
      info: {},
    };
  },
  computed: {
  },
  methods: {
    qiehuanFun(str) {
      if (this.isCompnentElement !== str) {
        this.isCompnentElement = str;
      }
    },
    initResumeFun() {
      resultCommons.apiResumelistinfo(this, { token: this.token }).then((ob) => {
        if (ob.state === 200) {
          this.info = ob.data;
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
  },
  components: {
    // 引入图片上传组件
    'ui-recruiment-trace': uiRecruimentTrace,
    'ui-recruiment-info': uiRecruimentInfo,
    'ui-recruiment-interview': uiRecruimentInterview,
  },
  created() {
    // 初始化简历
    this.initResumeFun();
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonRecruiment{
  box-shadow: 0 0 1rem rgba(0, 0, 0, .5);
  background: #F6F6F6;
  width: 480px;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  border-radius: 1rem;
  overflow: hidden;
  margin-top: 15px;
  margin-bottom: 15px;
  margin-right: 15px;
  &.appBool{
    height: 100%;
    margin: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .topBox{
    background-image: linear-gradient(180deg, #D4DFFA 20%,#EEEFF6 80%);
    background: #2A37FE;
    color: #FFFFFF;
  }
  .infoBox{
    padding: 15px;
    div.aa{
      border-bottom:1px solid rgba(0,0,0,0.15);
      h3{
        font-size: 23px;
        line-height: 45px;
      }
    }
    div.cc{
      display: flex;
      margin-top: 20px;
      span{
        display: inline-block;
        margin-right: 15px;
        flex: 1;
        color: rgba(255,255,255,0.5);
        i{
          font-style: normal;
          color: #FFFFFF;
        }
      }
    }
    div.bb{
      margin-top: 10px;
      span{
        flex: 1;
        color: rgba(255,255,255,0.5);
        i{
          font-style: normal;
          color: rgba(255,255,255,0.6);
        }
      }
    }
  }
  .menuBox{
    display: flex;
    padding-left: 15px;
    padding-right: 15px;
    span{
      flex: 1;
      display: inline-block;
      text-align: center;
      color: rgba(255,255,255,0.5);
      line-height: 2.6em;
      cursor:pointer;
      letter-spacing: 3px;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;
      &:hover{
        background: rgba(0,0,0,0.1);
      }
      &.active{
        background: rgba(0,0,0,0.2);
        color: #FFFFFF;
      }
      &:last-child{
        margin: 0;
      }
    }
  }
  .mainBox{
    flex: 1;
    display: flex;
    overflow:hidden;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/recruiment/index.vue